// extracted by mini-css-extract-plugin
export default {"confirm-modal":"Confirm_confirm-modal__qtk9H","content":"Confirm_content__3j2Jd","content-none":"Confirm_content-none__NwczE"};